import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Lesson_create($createLesson: CreateLesson) {
    Lesson_create(createLesson: $createLesson) {
      id
      name
      position
      file
      isDraft
      isPrivate
    }
  }
`;

const LessonCreate = async createLesson =>
  graphql(mutation, { createLesson }).then(
    // eslint-disable-next-line camelcase
    ({ Lesson_create }) => Lesson_create
  );

export default LessonCreate;
